// extracted by mini-css-extract-plugin
export default {"Card":"Infos_Card__FNQCV"};